import { useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import { useAdminAuth } from "@/admin/AuthContext";
import { Field, Input, YBtn } from "@/admin/ui";
import { errorMessage } from "@/lib/api";

export default function Login() {
  const { user, login } = useAdminAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [f, setF] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(f.email, f.password);
      toast.success("Welcome back!");
      nav(loc.state?.from || "/admin", { replace: true });
    } catch (e2) {
      setErr(errorMessage(e2));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grid min-h-screen lg:grid-cols-2">
      <div className="indigo-gradient relative hidden flex-col justify-between overflow-hidden p-12 text-white lg:flex">
        <div className="dot-grid absolute inset-0 opacity-20" aria-hidden="true" />
        <p className="relative font-heading text-lg font-extrabold">OWN BRAND <span className="text-sky">TECHNOLOGIES</span></p>
        <div className="relative">
          <h1 className="text-4xl font-extrabold text-white">Manage your website, leads and payments <span className="text-cta">in one place.</span></h1>
          <p className="mt-4 max-w-md text-white/70">Content, analytics, orders, legal pages and marketing settings, all from a single admin panel.</p>
        </div>
        <p className="relative text-xs text-white/50">Authorised personnel only.</p>
      </div>
      <div className="flex items-center justify-center bg-page p-6">
        <form onSubmit={submit} className="w-full max-w-sm rounded-2xl border border-line bg-white p-8 shadow-soft" data-testid="admin-login-form">
          <span className="grid h-12 w-12 place-items-center rounded-xl bg-indigo-brand text-cta"><Lock className="h-5 w-5" /></span>
          <h2 className="mt-5 text-2xl font-extrabold">Admin login</h2>
          <p className="mt-1 text-sm text-body">Sign in to continue to the dashboard.</p>
          <div className="mt-6 space-y-4">
            <Field label="Email"><Input type="email" required autoComplete="username" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} testId="admin-login-email" /></Field>
            <Field label="Password"><Input type="password" required autoComplete="current-password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} testId="admin-login-password" /></Field>
          </div>
          {err && <p className="mt-4 rounded-xl bg-red-50 px-3 py-2 text-sm font-medium text-red-700" data-testid="admin-login-error">{err}</p>}
          <YBtn type="submit" loading={loading} className="mt-6 w-full" testId="admin-login-submit">Sign in</YBtn>
        </form>
      </div>
    </div>
  );
}
